import axios from "axios"
import { mapState } from "vuex"
import { bus } from "@/main"

export const highlights = {
    data () {
        return {
            ranges: [],
            currentMarkIndex: 0,
            mark: {
                currentParentIndex: 0,
                currentChildIndex: 0
            },
            notes: {
                modal: false,
                data: null
            }
        }
    },
    computed: {
        ...mapState("user", ["user"])
    },
    methods: {
        showControls (selection) {
            const controls = document.getElementById("controls")

            // to get the position of the selection top and left px of the screen
            const rect = selection.getRangeAt(0).getBoundingClientRect()
            // scroll value because 'rect' only refers to screen height, not page height
            const scroll = document.documentElement.scrollTop

            controls.style.top = `calc(${rect.top}px + ${scroll}px - 45px)`
            controls.style.left = `${rect.left}px`
            controls.style.visibility = "visible"

            document.body.appendChild(controls)
        },

        hideControls () {
            document.getElementById("controls").style.visibility = "hidden"
        },

        getRangesFromDb () {
            const url = `/webbook-highlight/get/${this.user.id}/${this.currentUnit}`
            axios.get(url)
                .then(res => {
                    if (res.data.ranges.length) {
                        this.ranges = JSON.parse(res.data.ranges[0].ranges)
                        this.defaultDOM = document.body.innerHTML
                        this.highlightTextAfterLoad()
                    }
                })
                .catch(err => console.log(err))
        },

        saveRangesToDb () {
            const formData = {
                user_key: this.user.id,
                client: this.user.client,
                textbook_unit_id: this.currentUnit,
                ranges: JSON.stringify(this.ranges)
            }
            return new Promise((resolve, reject) => {
                axios.post("/webbook-highlight/create-or-update", formData)
                    .then(() => {
                        console.log("Highlight data saved.")
                        resolve()
                    })
                    .catch(err => {
                        this.changeOverlay(true, err.message.status, "Unable to save data. Check your connection and try again.")
                        reject(new Error("Unable to save data. Check your connection and try again."))
                    })
            })
        },

        addRange () {
            // bus.$emit("highlightDelay", true)
            if (document.getSelection().type === "Range" && this.pageType == "Preview") {
                const selection = document.getSelection().getRangeAt(0)
                const mark = document.createElement("mark")
                // checks if highlighted text is in the same parent element
                // prevents line breaks when highlighting
                if (selection.startContainer.parentElement.id != selection.endContainer.parentElement.id) {
                    // alert('You cannot highlight words from 2 different paragraphs.')
                    alert("서로 다른 두 단락의 단어를 강조 표시할 수 없음")
                    return
                }

                // check if element that contains text already exists
                const array = JSON.parse(JSON.stringify(this.ranges))
                const existingElementIndex = array.findIndex(element => element.id == selection.startContainer.parentElement.id)
                if (existingElementIndex < 0) { // if parent element does not exist
                    // if selection is inside a mark, this if statement triggers
                    // because the parentElement's id is now the id of that existing mark
                    const idCount = selection.startContainer.parentElement.id.split("-")
                    if (idCount.length == 2) {
                        alert("Selected words are already highlighted")
                        return
                    }
                    const data = {
                        id: selection.startContainer.parentElement.id,
                        ranges: [
                            {
                                startOffset: selection.startOffset,
                                endOffset: selection.endOffset,
                                color: "yellow",
                                notes: null
                            }
                        ]
                    }

                    this.ranges.push(data)
                    this.mark.currentParentIndex = this.ranges.length - 1
                    this.mark.currentChildIndex = 0
                }
                else { // if parent element already exist
                    const ranges = this.ranges[existingElementIndex]
                    const nodes = selection.startContainer.parentElement.childNodes
                    // select the index of the node that matches the text
                    const nodeIndexOfSelectedText = Array.from(nodes).findIndex(node => node.textContent == selection.startContainer.textContent)

                    // check if new selection offsets already exists or in between existing ranges

                    // determines where new offset starts
                    let accumulatedLength = 0
                    for (let i = 0; i < nodeIndexOfSelectedText; i++) {
                        nodes[i].textContent == selection.startContainer.textContent ? "" : accumulatedLength += nodes[i].textContent.length
                    }

                    // push to elements ranges
                    const data = {
                        startOffset: accumulatedLength + selection.startOffset,
                        endOffset: accumulatedLength + selection.endOffset,
                        color: "yellow",
                        notes: null
                    }
                    // saves original range positioning to update previous marks
                    const rangesBeforeSort = ranges.ranges.slice(0)

                    ranges.ranges.push(data)
                    ranges.ranges.sort((a, b) => a.startOffset > b.startOffset ? -1 : 1)

                    this.mark.currentParentIndex = existingElementIndex
                    this.mark.currentChildIndex = Array.from(ranges.ranges).findIndex(range => range.startOffset == data.startOffset)

                    // reset other marked ids in the same element
                    rangesBeforeSort.forEach((rangeBefore, indexBefore) => {
                        // find the new index
                        const index = Array.from(ranges.ranges).findIndex(range => range.startOffset == rangeBefore.startOffset)
                        const identifier = `${existingElementIndex}-${indexBefore}`
                        const mark = document.getElementById(identifier)
                        // update mark
                        mark.setAttribute("id", `${existingElementIndex}-${index}`)
                    })
                }

                // insert the mark
                mark.appendChild(selection.extractContents())
                const id = `${this.mark.currentParentIndex}-${this.mark.currentChildIndex}`
                mark.setAttribute("id", id)
                mark.classList.add("yellow")
                selection.insertNode(mark)

                // show controls
                this.showControls(document.getSelection())

                // save to database
                this.saveRangesToDb()

                // attach event
                this.attachEventsToMarks()
            }
        },

        async deleteHighlight () {
            bus.$emit("highlightDelay", true)
            // removes all marks in the parent's childnodes and return remaining ranges
            const identifier = `${this.mark.currentParentIndex}-${this.mark.currentChildIndex}`
            const parent = document.getElementById(identifier).parentElement
            const text = parent.textContent
            parent.innerHTML = text

            if (this.ranges[this.mark.currentParentIndex].ranges.length > 1) {
                this.ranges[this.mark.currentParentIndex].ranges.splice(this.mark.currentChildIndex, 1)

                Array.from(this.ranges[this.mark.currentParentIndex].ranges).forEach((data, dataIndex) => {
                    window.getSelection().removeAllRanges()
                    const range = document.createRange()

                    range.setStart(parent.childNodes[0], data.startOffset)
                    range.setEnd(parent.childNodes[0], data.endOffset)

                    const mark = document.createElement("mark")
                    mark.classList.add(data.color)
                    mark.setAttribute("id", `${this.mark.currentParentIndex}-${dataIndex}`)
                    mark.setAttribute("data-start", data.startOffset)

                    range.surroundContents(mark)
                    mark.normalize()
                })

                this.attachEventsToMarks()
            }
            else {
                this.ranges.splice(this.mark.currentParentIndex, 1)
            }
            await this.saveRangesToDb()
            setTimeout(() => {
                bus.$emit("highlightDelay", false)
            }, 1000)
        },

        highlightTextAfterLoad () {
            if (this.pageType == "Preview") {
                const items = JSON.parse(JSON.stringify(this.ranges))
                items.forEach((item, parentIndex) => {
                    const node = document.getElementById(item.id).childNodes[0]

                    item.ranges.forEach((data, dataIndex) => {
                        window.getSelection().removeAllRanges()
                        const range = document.createRange()

                        range.setEnd(node, data.endOffset)
                        range.setStart(node, data.startOffset)

                        const mark = document.createElement("mark")
                        mark.classList.add(data.color)
                        mark.setAttribute("id", `${parentIndex}-${dataIndex}`)
                        mark.setAttribute("data-start", data.startOffset)

                        range.surroundContents(mark)
                        mark.normalize()
                    })
                })
                this.attachEventsToMarks()
            }
        },

        changeColor (color) {
            const id = `${this.mark.currentParentIndex}-${this.mark.currentChildIndex}`
            const mark = document.getElementById(id)
            mark.removeAttribute("class")
            mark.classList.add(color)

            this.ranges[this.mark.currentParentIndex].ranges[this.mark.currentChildIndex].color = color
            this.saveRangesToDb()
        },

        attachEventsToMarks () {
            const marks = document.getElementsByTagName("mark")
            if (marks.length) {
                for (let i = 0; i < marks.length; i++) {
                    const mark = marks[i]
                    mark.addEventListener("click", () => {
                        const rect = mark.getBoundingClientRect()
                        const controls = document.getElementById("controls")
                        const scroll = document.documentElement.scrollTop

                        controls.style.top = `calc(${rect.top}px + ${scroll}px - 45px)`
                        controls.style.left = `${rect.left}px`
                        controls.style.visibility = "visible"

                        document.body.appendChild(controls)

                        const ids = mark.id.split("-")
                        this.mark.currentParentIndex = ids[0]
                        this.mark.currentChildIndex = ids[1]
                    })
                }
            }
        },

        openModal () {
            this.notes.data = this.ranges[this.mark.currentParentIndex].ranges[this.mark.currentChildIndex].notes
            this.notes.modal = true
        },

        saveNote () {
            this.ranges[this.mark.currentParentIndex].ranges[this.mark.currentChildIndex].notes = this.notes.data
            this.saveRangesToDb()
            this.notes.modal = false
        }
    }
}
